import React from 'react'
import { Global, css } from '@emotion/core'
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom'
import configureStore from './store/configureStore'
import { Provider } from 'react-redux'
import { hot } from 'react-hot-loader/root'
import '@fortawesome/fontawesome-free/css/all.min.css'

import './App.css'
import Layout from './page/layout/LayoutWeb'
// import Finnovo from './page/finnovo'

import './font/popinsRagular/PoppinsRegular.css'

const store = configureStore(window.__INITIAL_STATE__)

const globalStyles = css`
  html,
  body {
    font-family: 'PoppinsRegular';
    /* background: #fcfcfc; */
  }
`

export const App = () => {
  return (
    <Provider store={store}>
      <Global styles={globalStyles} />
      {/* <Suspense fallback={null}> */}
      <Router>
        <Switch>
          <Route component={Layout} />
        </Switch>
      </Router>
      {/* </Suspense> */}
    </Provider>
  )
}

if (module.hot) {
  module.hot.dispose(() => (window.__INITIAL_STATE__ = store.getState()))
}

export default process.env.NODE_ENV === 'development' ? hot(App) : App
